"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Aug 13 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ProductInfoConverter.
 *
 * @author Jaroslav Sevcik
 */


var ProductInfoConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductInfoConverter, _DataObjectConverter_);

  function ProductInfoConverter() {
    _classCallCheck(this, ProductInfoConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductInfoConverter).apply(this, arguments));
  }

  return ProductInfoConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductInfoConverter = ProductInfoConverter;